import { useRouter } from 'next/router';
import { HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { routeHasCompanySlug } from '../../util/routes';
import { CompanyHeader } from '../Header/CompanyHeader';

type Props = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const BasicPage = ({ children, className }: Props) => {
  const { query } = useRouter();
  const isCompanyPage = routeHasCompanySlug(query);

  const classname = clsx('basic-page mx-auto w-full', className);

  return (
    <div className={classname}>
      {isCompanyPage && <CompanyHeader />}
      {!isCompanyPage && <Header />}

      <div className="content">{children}</div>
      <Footer />
    </div>
  );
};

export default BasicPage;
